<template>
  <div class="x-mt-8 x-flex x-flex-col x-gap-12 desktop:x-mt-0">
    <h1 class="x-title4 x-title4-sm x-uppercase x-text-neutral-75">
      {{ $t('popularSearches.title') }}
    </h1>
    <PopularSearches
      :animation="animation"
      :max-items-to-render="4"
      class="x-flex x-gap-8 desktop:!x-flex-col desktop:x-gap-4"
      :class="{ '!x-flex-row !x-flex-wrap': !x.query.searchBox }"
    >
      <template #suggestion="{ suggestion }">
        <PopularSearch
          :class="`x-suggestion x-suggestion-md x-text2 !x-text2-lg x-font-alternative ${suggestionClass}`"
          :suggestion="suggestion"
        >
          <TrendingIcon class="x-icon-lg desktop:x-icon-md" />
          <span>{{ suggestion.query }}</span>
        </PopularSearch>
      </template>
    </PopularSearches>
  </div>
</template>

<script setup lang="ts">
import type { AnimationProp } from '@empathyco/x-components'
import { TrendingIcon, use$x } from '@empathyco/x-components'
import { PopularSearch, PopularSearches } from '@empathyco/x-components/popular-searches'
import { computed } from 'vue'
import { useDevice } from '../../composables/use-device.composable'

defineProps<{
  animation: typeof AnimationProp
}>()

const { isDesktopOrGreater } = useDevice()
const x = use$x()

const suggestionClass = computed(() =>
  !isDesktopOrGreater.value && !x.query.searchBox
    ? 'x-px-12 x-border-1 x-border-neutral-25 x-items-baseline x-rounded-full'
    : '',
)
</script>
<style lang="scss"></style>
